<template>
  <span v-if="typeof value == 'number'">
    <b-icon-record-fill v-if="small" :variant="variant(value)" />
    <b-badge v-else :variant="variant(value)">{{ value }}</b-badge>
  </span>
</template>
<script>

export default {
  name: 'Score',
  props: {
    value: [Number, String],
    small: Boolean,
  },
  methods: {
    variant: function(value) {
      return value >= process.env.VUE_APP_SCORE_HIGH ? 'success' : value >= process.env.VUE_APP_SCORE_MEDIUM ? 'warning' : 'danger'
    },
  },
}
</script>
